export default {
  schema: {
    title: 'Screen Name',
    type: 'object',
    required: ['username'],
    properties: {
      username: {
        title: 'Username',
        type: 'string'
      }
    }
  },
  uiSchema: {
    textFieldsHeader: {
      'ui:title': {
        text: '<b>Decorated Text Fields</b>',
        escape: false
      }
    },
    username: {
      'ui:widget': 'text',
      'ui:options': {
        before: '@',
        icons: ['PUBLICLY_AVAILABLE', 'READ_ONLY']
      }
    },
    'dm:layout': [{
      type: 'text',
      id: 'textFieldsHeader'
    }, {
      type: 'field',
      id: 'username'
    }]
  },
  formData: {}
};